import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useI18n } from "../i18n/i18n";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_cloudship-azure/artifacts/kktuux3j_cloudship_cloud_icon.svg";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#1e2d3d]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img
              src={LOGO_URL}
              alt="Cloudship"
              className="h-10 w-10 object-contain"
            />
            <span className="font-display text-lg text-white">Cloudship</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            {t("footer.tagline")}
          </p>
        </div>

        <div>
          <p className="cs-overline mb-4">{t("footer.nav_title")}</p>
          <ul className="space-y-2 text-sm">
            <li><a href="/#services" className="text-slate-300 hover:text-sky-400" data-testid="footer-nav-services">{t("nav.services")}</a></li>
            <li><a href="/#methodology" className="text-slate-300 hover:text-sky-400" data-testid="footer-nav-methodology">{t("nav.methodology")}</a></li>
            <li><a href="/#about" className="text-slate-300 hover:text-sky-400" data-testid="footer-nav-about">{t("nav.about")}</a></li>
            <li><Link to="/blog" className="text-slate-300 hover:text-sky-400" data-testid="footer-nav-blog">{t("nav.blog")}</Link></li>
            <li><Link to="/impressum" className="text-slate-300 hover:text-sky-400" data-testid="footer-nav-impressum">{t("footer.legal_note")}</Link></li>
            <li><Link to="/datenschutz" className="text-slate-300 hover:text-sky-400" data-testid="footer-nav-privacy">{t("footer.privacy_note")}</Link></li>
          </ul>
        </div>

        <div>
          <p className="cs-overline mb-4">{t("footer.services_title")}</p>
          <ul className="space-y-2 text-sm text-slate-300">
            <li>Cloud Strategy</li>
            <li>Enterprise-Scale Landing Zones</li>
            <li>Cloud Adoption Framework</li>
            <li>Well-Architected Reviews</li>
            <li>Automation & DevOps</li>
          </ul>
        </div>

        <div>
          <p className="cs-overline mb-4">{t("footer.contact_title")}</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3 text-slate-300">
              <Mail className="w-4 h-4 text-sky-400 mt-1 shrink-0" />
              <div className="flex flex-col">
                <a href="mailto:info@cloud-ship.de" className="hover:text-sky-400" data-testid="footer-email">info@cloud-ship.de</a>
                <a href="mailto:samer.alshreibati@cloud-ship.de" className="text-slate-400 text-xs hover:text-sky-400" data-testid="footer-email-direct">samer.alshreibati@cloud-ship.de</a>
              </div>
            </li>
            <li className="flex items-center gap-3 text-slate-300">
              <Phone className="w-4 h-4 text-sky-400" />
              <a href="tel:+4915732521421" className="hover:text-sky-400" data-testid="footer-phone">+49 157 32521421</a>
            </li>
            <li className="flex items-center gap-3 text-slate-300">
              <MapPin className="w-4 h-4 text-sky-400" />
              <span>{t("contact.info.location_value")}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="cs-divider" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <p className="text-xs text-slate-500">
          © {year} Cloudship. {t("footer.rights")}
        </p>
        <div className="flex items-center gap-5">
          <Link
            to="/impressum"
            className="text-xs text-slate-500 hover:text-sky-400"
            data-testid="footer-impressum-link"
          >
            {t("footer.legal_note")}
          </Link>
          <Link
            to="/datenschutz"
            className="text-xs text-slate-500 hover:text-sky-400"
            data-testid="footer-privacy-link"
          >
            {t("footer.privacy_note")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
